import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import Loader from '../../../components/loader/Loader'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import InputDropdown from "../../../components/input-dropdown/InputDropdown";
import { SortedTable, SortLink } from 'vue-sorted-table'
import { ScreenLoader } from '../../../utils/loading.util'
import {BookingOption, BookingService} from "@/services/booking.service";
import booking from "@/views/booking/booking";
import {LocationDropdown, LocationService} from "@/services/location.service";

export default {
    name: "Options",
    components: {
        NavigationBar,
        TabBar,
        InputDropdown,
        SortedTable,
        SortLink,
        Loader,
        InputButton,
        InputText,
    },

    data() {
        return {
            searchValue: '',
            options: [],
            sortedOptions: [],
            screenLoader: new ScreenLoader(),
            locations: [],
            dropdownLocations: [],
            selectedLocation: undefined
        }
    },

    async mounted() {
        this.locations = await LocationService.getLocations()
        this.dropdownLocations = this.locations.map(location => new LocationDropdown(location))
        this.selectedLocation = this.dropdownLocations[0]
        await this.getOptions(this.selectedLocation.id)
    },

    methods : {
        search() {
            this.sortedOptions = this.options.filter(option => {
                const foundName = this.propertyContainsValue(option.name)
                return foundName
            })
        },

        propertyContainsValue(value) {
            return value ? value.toLowerCase().includes(this.searchValue.toLowerCase()) : false
        },

        clearSearch() {
            this.searchValue = ''
            this.sortedOptions = this.options
        },

        getOptions: async function(locationId) {
            this.screenLoader.start()

            try {
                const options = await BookingService.getBookingOptions(locationId)
                this.handleOptionsResponse(options)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleOptionsResponse(options) {
            this.options = options.map(o => new BookingOption(o))
            this.sortedOptions = this.options
            this.screenLoader.stop()
        },

        doAddNewBookingOption() {
            router.push(`/settings/options/${this.selectedLocation.id}/${undefined}`)
        },

        doEditNewBookingOption(id) {
            router.push(`/settings/options/${this.selectedLocation.id}/${id}`)
        },

        async updateLocation(locationUpdate) {
            this.selectedLocation = this.dropdownLocations.find(location => location.id === locationUpdate)
            this.options = await this.getOptions(locationUpdate)
        }
    }
}
